import Vue from "vue";

const store = Vue.observable({
  FB: {},
  FBscope: {},
  currentUser: {},
  currency: {}
});


export default store;